module.exports = __webpack_public_path__ + "9d9cf45f1830c062c89a83de2c9ddeb8.png";